/* Angular Component */
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import { UI } from "../../services/ui.service";
import { NavigationItemModel } from "../common/sideNav/navigationItem.model";
import { UserService } from "../../domain/user-service";
import { PopoverService } from "../../services/popover-service";
import { NgxSmartModalService } from "ngx-smart-modal";

@Component({
  selector: "scheduler",
  templateUrl: "./scheduler.component.html",
  styleUrls: ["./scheduler.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchedulerComponent {
  bottom = 'bottom' as const;
  filterOpen = false;
  filterTranslateValue = "";
  showPopover = false;
  navigationItems: NavigationItemModel[];
  uploadOrAdd: "Upload" | "Add" = "Upload";
  showLibraryItemMenuButtons = true;

  @ViewChild("fileInput") fileInput: ElementRef;

  constructor(
    private ui: UI,
    private element: ElementRef,
    private userService: UserService,
    private popoverService: PopoverService,
  ) {
    this.navigationItems = [];
  }

  getContractDescriptionText() {
    return (
      "You can upload files or add placeholder" +
      "\n" +
      "contracts (empty assets) to your media panel"
    );
  }
  addContract() {
    this.popoverService.outputEvent("Add Contract", null);
  }

  onUploadFileChange(event) {
    this.popoverService.outputEvent("Upload File", event);
  }

  ngOnDestroy() {
    window.removeEventListener("resize", this.onResizeWindow, false);
  }

  async ngOnInit() {
    const currentChannel = await this.userService.getCurrentChannel();
    if (currentChannel) {
      const currentUser = this.userService.getCurrentUser();
      if (currentUser && currentUser.hasEditMAMPermission) {
        this.navigationItems.push(
          ...[
            new NavigationItemModel("video", "video-icon", "media"),
            new NavigationItemModel("live", "live-icon", "live"),
            new NavigationItemModel("graphics", "graphics-icon", "graphics"),
            new NavigationItemModel("layouts", "layout-icon", "layouts"),
            new NavigationItemModel("blocks", "blocks-icon", "blocks"),
          ],
        );
      }
      if (currentUser && currentUser.isSuperUser) {
        //this.navigationItems.push(new NavigationItemModel('dynamicPromo', 'dynamic-promo-icon', 'Dynamic Promo'));
      }

      if (currentUser && currentUser.hasEditMAMPermission) {
        // this.navigationItems.push(new NavigationItemModel('markers', 'markers-icon', 'markers'));
      }
      if (currentUser && currentUser.isBroadcastsManager) {
        this.navigationItems.push(
          new NavigationItemModel(
            "broadcasts",
            "broadcasts-icon",
            "Broadcast Presets",
          ),
        );
      }
    }
    window.addEventListener("resize", this.onResizeWindow.bind(this), false);
    this.popoverService.openPopover.subscribe(() => {
      this.showPopover = true;
    });
    this.popoverService.closePopover.subscribe(() => {
      this.showPopover = false;
    });
    /* Setup Filter Left Position */
    this.setupFilterLeftPosition();

    /* Adding listener to filter toggle */
    this.ui.listen(
      this.ui.EVENTS.LibraryFilterToggle,
      this.onLibraryFilterToggle.bind(this),
    );
  }
  onResizeWindow(event) {
    this.setupFilterLeftPosition();
    this.filterOpen = false;
  }

  /**
   * dispatch when user click outside the filter
   * @param event
   */
  closeFilter(event) {
    this.ui.notify(this.ui.EVENTS.LibraryFilterToggle, {
      source: "curtain",
    });
  }

  /**
   * Dispatched in case of filter toggle (Should display / Hide Filter)
   * @param event
   * @return void
   */
  onLibraryFilterToggle(event) {
    this.filterOpen = !this.filterOpen;

    const $filter = this.element.nativeElement.querySelector("filter");

    /* Perform open set of operations */
    this.ui.setCssProperty($filter, {
      transform:
        "translateX(" +
        (this.filterOpen ? "0" : "-" + this.filterTranslateValue) +
        ")",
    });
  }

  /**
   * Setup Filter Left Position
   * @return void
   */
  setupFilterLeftPosition() {
    /* Getting Filter Element */
    const $filter = this.element.nativeElement.querySelector("filter");

    if ($filter == null || !$filter) {
      return;
    }

    /* Getting Computed Element */
    const asideWidth = this.ui.getComputedElement(
      this.element.nativeElement.querySelector("aside"),
      "width",
    );
    const tabsWidth = this.ui.getComputedElement(
      document.querySelector("icn-sidebar-nav"),
      "width",
    );

    const filterWidth = this.ui.getComputedElement($filter, "width");

    /* Assign Filter Translate Value */
    this.filterTranslateValue = filterWidth;
    // console.log("FILTER WIDTH: ", filterWidth, "--->?", "translateX(" + this.filterTranslateValue + ")" );

    const leftPosition = parseFloat(asideWidth) + parseFloat(tabsWidth);

    this.ui.setCssProperty($filter, {
      left: `${leftPosition}px`,
      transform: "translateX(-" + this.filterTranslateValue + ")",
    });
  }
}
